//App purchase status
export const SAVE_PURCHASE_STATUS = 'save_purchase_status';
export const GET_PURCHASE_STATUS = 'get_purchase_status';
export const CLAIM_YOUR_PURCHASE = 'claim_your_purchase';
export const VIEWCARD = 'viewcard';

//Login Action Types
export const LOGIN = 'login';
export const LOGIN_REQUEST = 'login_request';
export const LOGOUT = 'logout';
export const GOTO_FLASH = 'gotoflash';

//Sign up Action Types
export const SIGNUP_REQUEST = 'signUp_request';
export const FETCH_COMPANIES_REQUEST = 'fetch_companies_request';
export const SHOW_COMPANIES = 'show_companies';
export const SAVE_MY_NAME_COMPANY = 'save_my_name_company';

//Forgot Model Action Types
export const SHOW_FORGOT_MODAL = 'show_forgot_Modal';
export const FORGET_PASSWORD_REQUEST = 'forget_password_request';
export const FORGET_PASSWORD_SUCCESS = 'forget_password_success';
export const UPDATE_INTERNET_STATUS = 'update_internet_status';

//Change Password Action Types
export const CHANGE_PASSWORD = 'change_password';

//Unlock Pchievement Action Type
export const UNLOCK_ACHIEVEMENT = 'unlock_achievement';
export const ACHIEVEMENT_UNLOCKED = 'achievement_unlocked';

//Dashboard Action Type
export const GET_ALL_INITIAL_DASHBOARD_DATA = 'get_all_initial_dashboard_data';
export const TOGGLE_LOADING_DASHBOARD = 'toggle_loading_dashboard';
export const FETCH_DASHBOARD_DETAILS = 'fetch_dashboard_details';
export const UPDATE_DASHBOAD_DETAILS = 'update_dashboard_details';
export const FETCH_LEADERBOARD_DETAILS = 'fetch_leaderboard_details';
export const UPDATE_LEADERBOARD_DETAILS = 'update_leaderboard_details';
export const FETCH_ACHIEVEMENT_DETAILS = 'fetch_achievement_details';
export const UPDATE_ACHIEVEMENT_DETAILS = 'update_achievement_details';
export const FETCH_CHALLENGE_SEND_LIST = 'fetch_challenge_send_list';
export const UPDATE_CHALLENGE_SEND_LIST = 'update_challenge_send_list';
export const FETCH_CHALLENGE_ACCEPT_LIST = 'fetch_challenge_accept_list';
export const UPDATE_CHALLENGE_ACCEPT_LIST = 'update_challenge_accept_list';
export const FETCH_CHALLENGE_HISTORY_LIST = 'fetch_challenge_history_list';
export const UPDATE_CHALLENGE_HISTORY_LIST = 'update_challenge_history_list';
export const UPDATE_CHALLENGE_STATUS = 'update_challenge_status';

//TopicsScreen Action Types
export const GET_MAIN_TOPICS = 'get_main_topics';
export const SHOW_MAIN_TOPICS = 'show_main_topics';
export const GET_SUB_TOPICS = 'get_sub_topics';
export const SHOW_SUB_TOPICS = 'show_sub_topics';

//Navigation Action Types
export const SHOW_SIGNUP = 'show_signup_screen';
export const SHOW_TERMS_CONDITIONS = 'show_terms_screen';
export const SHOW_LOGIN = 'show_login_screen';
export const SHOW_LOGIN_FORWARD = 'goto_login_screen';
export const SHOW_FLASHCARD = 'show_flashcard_screen';
export const SHOW_DISPLAY_FLASHCARD = 'show_dispaly_flashcard_screen';
export const BACKTO_FLASHCARD = 'backTo_flashcard';
export const BACK_FROM_CURRENT_SCREEN = 'back_from_current_screen';
export const SHOW_QUESTIONS_SCREEN = 'show_questions_screen';
export const BACK_TO_TOPIC_SCREEN = 'back_To_topicScreen';
export const CHECKLOGIN = 'check_for_already_login';
export const TUTORIAL_SCREEN = 'show_tutorial_screen';
export const SHOW_VIDEO = 'SHOW_VIDEO';

export const BACK_FROM_TERMS = 'back_from_terms';
export const BACK_FROM_QUESTIONS = 'back_from_questions';
export const BACK_FROM_SIMULATED_TEST = 'back_from_simulated_test';
export const GOTO_SIMULATED_TEST = 'goto_simulated_test';
export const SHOW_SIMULATED_TEST = 'show_simulated_test';
export const TABBED_SCREEN_INDEX_UPDATE = 'tabbed_screen_index_update';

export const SHOW_LEADERBOARD_SCREEN = 'show_leaderboard_screen';
export const SHOW_ACHIEVEMENT_SCREEN = 'show_achievement_screen';
export const SHOW_TESTRESULT_SCREEN = 'show_testresult_screen';
export const SHOW_RECEIVE_CHALLENGE_SCREEN = 'show_receive_challenge_screen';
export const SHOW_CONTENT_MANUAL_SCREEN = 'show_content_manual_screen';
export const SHOW_CARD_INPUT_SCREEN = 'show_card_input_screen';
export const SHOW_SPEED_TEST_SCREEN = 'show_speed_test_screen';
export const SHOW_CAROUSAL_SCREEN = 'show_carousal_screen';
export const CAROUSAL_VALUE = 'carousal_value';

//FlashCard Action Types
export const UPDATE_FLASHCARD = 'update_flashcard';
export const RESET_FLASHCARD = 'reset_flashcard';
export const FLASHCARD_COUNT_REQUEST = 'flashcard_count_request';
export const FLASHCARD_COUNT = 'cards_count';
export const USER_FLASHCARD_DETAILS = 'user_flashcard_details';
export const FLASHCARD_INDEX = 'flashCard_index';
export const LOADING_CARDS = 'loading_flashcard';

//Display FlashCard Action Types
export const FLASHCARD_LIST_REQUEST = 'flashcard_list_request';
export const LIST_OF_CARDS = 'list_of_cards';
export const FLASHCARD_VIEWED_HIDDEN_STATUS = 'flashcard_viewed_hidden_status';

//Loading actions
export const START_LOADING = 'start_loading';
export const STOP_LOADING = 'stop_loading';

//Welcome screen after login
export const SHOW_WELCOME_SCREEN = 'show_welcome_screen';
export const HIDE_WELCOME_SCREEN = 'hide_welcome_screen';

//Question Screen Action Types
export const QUESTION_BY_ID = 'question_by_id';
export const LIST_OF_QUESTIONS = 'list_of_questions';
export const SUBMIT_QUESTION_TEST_RESPONSE = 'question_test_response';
export const SUBMIT_QUESTION_TEST_RESPONSE_ONBACK =
  'question_test_response_onback';
export const RESET_HIDDEN_QUESTIONS = 'reset_hidden_questions';
export const HIDDEN_QUESTIONS = 'hidden_questions';

//Video Topic Screen Action Types
export const GET_VIDEO_MAIN_TOPICS = 'get_video_main_topics';
export const SHOW_VIDEO_MAIN_TOPICS = 'show_video_main_topics';
export const GET_VIDEOS = 'get_videos';
export const SHOW_VIDEOS = 'show_videos';

//reset password action
export const RESET_PASSWORD = 'reset_password_field';
export const LOGIN_STATUS = 'login_status';

//Simulated Test actions
export const LIST_OF_SIMULATED_QUESTIONS = 'list_of_simulated_questions';
export const SUBMIT_SIMULATED_TEST_RESULT = 'submit_simulated_test_result';

//Send Challenge action
export const SUBMIT_CHALLENGE_REQUEST = 'submit_challenge_request';

//Accept Challenge action
export const SAVE_ACCEPT_CHALLENGE_REQUEST_DATA =
  'save_accept_challenge_request_data';

//Challenge History action
export const SUBMIT_CHALLENGE_HISTORY = 'submit_challenge_history';

//Payment Authentication action
export const MAKE_A_PAYMENT = 'make_a_payment';

//PromoCode Related Action
export const REQUEST_PROMO_CODE = 'request_promo_code';
export const UPDATE_PROMO_CODE = 'update_promo_code';
export const APPLY_PROMO_CODE = 'apply_promo_code';
export const UPDATE_PRICE = 'update_price';
export const CLEAR_PROMO_CODE = 'claer_promo_code';
